<template>
  <div :class="{ requiredLabel: required }">
    <v-autocomplete
      outlined
      dense
      persistent-hint
      clearable
      open-on-clear
      :item-text="itemText"
      :item-value="itemValue"
      :filter="filterItems"
      :search-input.sync="searchItem"
      no-data-text="データが見つかりません。"
      v-on="$listeners"
      v-bind="$attrs"
      @input="(v) => $emit('input', v)"
    >
      <template v-slot:no-data>
        <v-list-item>
          <strong>「{{ searchItem }}」</strong>に一致する結果はありません。
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      required: false,
      default: "name",
    },
    itemValue: {
      type: String,
      required: false,
      default: "id",
    },
  },
  name: "CustomAutocompleteSingle",
  data() {
    return {
      searchItem: "",
    };
  },
  methods: {
    filterItems: function (item, queryText, itemText) {
      if (queryText) {
        queryText = queryText.trim();
      }
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
  },
};
</script>

<style lang="scss">
.requiredLabel label {
  &:after {
    font-weight: bold;
    content: " *";
    color: #ff5252;
    font-size: 17px;
  }
}
</style>
